(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('shoppingCartService', shoppingCartService);

    function shoppingCartService() {
        var service = {
        };
        //==Main==
        return service;
        //========
    }
})();